const Front = () =>import ('../../views/Front.vue')
const Home = () =>import ('../../views/Home.vue')
const ItemDetail = () =>import ('../../views/ItemDetail.vue')
const PromoCode = () =>import ('../../views/PromoCode.vue')
const BannerItems = () =>import ('../../views/BannerItems.vue')
const MasterSearch = () =>import ('../../views/MasterSearch.vue')
const CategoryList = () =>import ('../../views/CategoryList.vue')
const Information = () =>import ('../../views/Information.vue')
const QR = () =>import ('../../views/Qr.vue')
const Feedback = () =>import ('../../views/Feedback.vue')
const Reservation = () =>import ('../../views/Reservation.vue')
const ReferralCode = () =>import ('../../views/ReferralCode.vue')
const ChowmanPay = () =>import ('../../views/ChowmanPay.vue')
const giftVoucher = () =>import ('../../views/GiftVoucher.vue')
const giftVoucherHistory = () =>import ('../../components/giftVoucherHistory.vue')
const ChowmanPayHistory = () =>import ('../../components/ChowmanPayHistory.vue')
const QRView = () =>import ('../../views/QRView.vue')

const restaurant = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: 'reservation',
        name: 'reservation',
        component: Reservation
    },
    {
        path: 'outlet/reservation/:restaurant_name',
        name: 'vendor',
        component: ItemDetail
    },
    // {
    //     path: 'outlet/:delivery_type/:restaurant_name/:item_slug',
    //     name: 'vendor_item',
    //     component: ItemDetail
    // },
    {
        path: 'promo-code',
        name: 'promo-code',
        component: PromoCode
    },
    {
        path: 'banner-items/:banner_id',
        name: 'banner-items',
        component: BannerItems
    },
    {
        path: 'search',
        name: 'search',
        component: MasterSearch
    },
    {
        path: 'category/:category_id',
        name: 'category',
        component: CategoryList
    },
    {
        path: 'details',
        name: 'details',
        component: Information
    },
    {
        path: 'qr/:restaurantid',
        name: 'qr',
        component: QR
    },
    {
        path: 'feedback/:restaurantid',
        name: 'feedback',
        component: Feedback
    },
    {
        path: 'referral-code',
        name: 'referral-code',
        component: ReferralCode
    },
    {
        path: 'chowman-pay',
        name: 'chowman-pay',
        component: ChowmanPay
    },
    {
        path: 'gift-voucher',
        name: 'gift-voucher',
        component: giftVoucher
    },
    {
        path: 'gift-voucher-history',
        name: 'gift-voucher-history',
        component: giftVoucherHistory
    },
    {
        path: 'chowman-pay-history',
        name: 'chowman-pay-history',
        component: ChowmanPayHistory
    },
    {
        path: 'restaurant-details/:restaurantId',
        name: 'restaurant-details',
        component: ItemDetail
    },
    {
        path: 'qr',
        name: 'qr',
        component: QRView
    }
    
]

export default restaurant;